var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['reo-input-wrap', _vm.type]},[_c('input',{class:['reo-input', {'has-icon': _vm.icon}],attrs:{"type":"text","placeHolder":_vm.placeHolder,"readonly":_vm.readonly,"spellcheck":"false"},domProps:{"value":_vm.data},on:{"input":_vm.updateValue}}),_vm._v(" "),(_vm.icon)?_c('span',{class:['reo-input-icon', _vm.icon]}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-225c1e4e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/basic/Input.vue
// module id = null
// module chunks = 